import { SVGProps } from "react";

export function MoneyBillWave({
  style,
  className,
  ...props
}: {
  style?: React.CSSProperties;
  className?: string;
} & SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      style={style}
      className={className}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.6667 32.4443C42.6667 39.3221 37.8889 44.8888 32 44.8888C26.0111 44.8888 21.3333 39.3221 21.3333 32.4443C21.3333 25.5665 26.0111 19.9999 32 19.9999C37.8889 19.9999 42.6667 25.5665 42.6667 32.4443ZM30.2222 28.8888V35.9999H29.3333C28.3556 35.9999 27.5556 36.7999 27.5556 37.7776C27.5556 38.7554 28.3556 39.5554 29.3333 39.5554H34.6667C35.6444 39.5554 36.4444 38.7554 36.4444 37.7776C36.4444 36.7999 35.6444 35.9999 34.6667 35.9999H33.7778V27.111C33.7778 26.1332 32.9778 25.3332 32 25.3332H30.2222C29.2444 25.3332 28.4444 26.1332 28.4444 27.111C28.4444 28.0888 29.2444 28.8888 30.2222 28.8888ZM0 50.8332V16.5554C0 13.8654 2.82 12.081 5.37222 12.7821C14.2444 15.1221 23.1222 12.9565 32 10.6943C41.6556 8.23319 51.3111 5.77208 60.9667 9.36208C62.8667 10.0665 64 11.9954 64 14.0554V48.2332C64 51.0221 61.1778 52.811 58.6333 52.011C49.7556 49.6665 40.8778 51.9332 32 54.1888C22.3444 56.6554 12.6889 59.111 3.03222 55.5221C1.13444 54.8221 0 52.8888 0 50.8332ZM31.0222 48.9332C37.2333 47.3443 44.2889 45.5443 51.6111 45.7443C52.0667 42.2554 55.0556 39.5554 58.6667 39.5554V19.9999C54.7444 19.9999 51.5667 16.8221 51.5556 12.9043C46.3333 12.7154 40.8 13.9621 34.4778 15.5665C33.9889 15.6887 33.4889 15.8221 32.9778 15.9554C26.7667 17.5443 19.7111 19.3443 12.3889 19.1443C11.9333 22.6332 8.94778 25.3332 5.33333 25.3332V44.8888C9.25556 44.8888 12.4333 48.0665 12.4444 51.9888C17.5667 52.1776 23.2 50.9221 29.5222 49.3221C30.0111 49.1999 30.5111 49.0665 31.0222 48.9332Z"
        fill="black"
      />
    </svg>
  );
}
